import React from "react";
import { Link } from "react-router-dom";

const Card = ({ article }) => {
  return (
    <Link to={`/article/${article.slug}`}>
      <div class="max-w-lg mx-3 shadow-lg lg:shadow-none mb-10 font-poppins">
        <div class="bg-white  border-gray-200 max-w-sm mb-5">
          <a href="#">
            <img
              class="rounded-t-lg"
              src={article.image.url}
              alt={article.image.url}
              height="233"
            />
          </a>
          <div class="p-5">
            <a href="#">
              <h5
                id="title"
                class="text-gray-900 font-bold text-2xl tracking-tight mb-2"
              >
                {article.title}
              </h5>
            </a>
            <p className="text-right text-gray-400 mb-4">
              Posted {article.published}
            </p>
            <p id="description" class="font-normal text-gray-700 mb-3">
              {article.description}
            </p>
            <a
              class="text-white bg-main-color hover:bg-orange-dark focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-3 py-2 text-center inline-flex items-center"
              href="#"
            >
              Read Article
            </a>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card;
